// extracted by mini-css-extract-plugin
module.exports = {"container":"e","content":"f","title":"g","description":"h","button":"i","image":"j"};